import { AppServiceFactory } from '@modules/app/service/AppServiceFactory';
import { IAppService } from '@modules/app/service/IAppService';
import { HistoryServiceFactory } from '@modules/canvas/services/history/HistoryServiceFactory';
import { IHistoryService } from '@modules/canvas/services/history/IHistoryService';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { IFddmService } from '@/modules/canvas/services/Floorplan/IFddmService';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { CopyPasteServiceFactory } from '@/modules/copy';

import { IKeyMap } from './IKeyMap';
import { Shortcut } from '../types';

export class CanvasLayoutKeyMap implements IKeyMap {
  private appSvc: IAppService;
  private historySvc: IHistoryService;
  private fddmSvc: IFddmService;
  private appStore: typeof useAppStore;

  public constructor() {
    this.appSvc = AppServiceFactory.getInstance().createAppService();
    this.historySvc = HistoryServiceFactory.getInstance().createHistoryService();
    this.fddmSvc = FddmServiceFactory.getInstance().createFddmService();
    this.appStore = useAppStore;
  }

  handleKeyPress(shortcut: Shortcut): void {
    switch (shortcut.code) {
      case 'Escape': {
        this.appSvc.resetTool();
        break;
      }
      case 'Backspace':
      case 'Delete': {
        const { selectedIds } = this.appStore.getState();
        this.fddmSvc.deleteSelection(selectedIds);
        this.appSvc.resetSelection();
        break;
      }

      case 'KeyC': {
        if (shortcut.ctrl) {
          CopyPasteServiceFactory.getInstance().createService().copySelectionToMemory();
          break;
        }
        if (shortcut.shift) {
          this.appSvc.activateTool('distcon');
          break;
        }
        this.appSvc.activateTool('charging');
        break;
      }

      case 'KeyD': {
        if (shortcut.ctrl) {
          CopyPasteServiceFactory.getInstance().createService().duplicateSelection();
          break;
        }

        this.appSvc.activateTool('delivery');

        break;
      }

      case 'KeyA': {
        if (shortcut.ctrl) {
          this.appSvc.selectAll();
        }
        break;
      }

      case 'KeyE': {
        if (shortcut.ctrl) {
          this.appSvc.activateTool('extraction');
          break;
        }
        break;
      }

      case 'KeyF': {
        this.appSvc.activateTool('transport_flow');
        break;
      }

      case 'KeyH': {
        if (shortcut.shift) {
          this.appSvc.activateTool('highway');
          break;
        }
        this.appSvc.activateTool('pan');
        break;
      }

      case 'KeyI': {
        if (shortcut.ctrl) {
          this.appSvc.activateTool('insertion');
          break;
        }
        this.appSvc.activateTool('intake');
        break;
      }

      case 'KeyM': {
        this.appSvc.activateTool('manual');
        break;
      }

      case 'KeyO': {
        this.appSvc.activateTool('obstacle');
        break;
      }

      case 'KeyP': {
        this.appSvc.activateTool('parking');
        break;
      }

      case 'KeyR': {
        this.appSvc.activateTool('racking');
        break;
      }

      case 'KeyS': {
        if (shortcut.ctrl) {
          this.appSvc.finalizeRevision();
          break;
        }
        this.appSvc.activateTool('storage');
        break;
      }

      case 'KeyT': {
        this.appSvc.activateTool('logical_space');
        break;
      }

      case 'KeyV': {
        if (shortcut.ctrl) {
          CopyPasteServiceFactory.getInstance().createService().pasteFromMemory();
          break;
        }

        this.appSvc.activateTool('cursor');
        break;
      }

      case 'KeyW': {
        this.appSvc.activateTool('wall');
        break;
      }

      case 'KeyY': {
        if (shortcut.ctrl) {
          this.historySvc.redo();
          break;
        }
        break;
      }

      case 'KeyZ': {
        if (shortcut.ctrl) {
          this.historySvc.undo();
          break;
        }
        break;
      }

      default:
        break;
    }
  }
}
